import React from "react";
import { StompSessionProvider } from "react-stomp-hooks";
import { SubscriptionsHook } from "./SubscriptionsHooks";
import { SubscriptionInfos, SubscriptionSocket } from "./SubscriptionSocket";

export type StompFilter = {
  field: string;
  operator: string;
  value: string;
};

interface Props {
  webSocketUrl: string;
  authToken: string;
  children: React.ReactElement[];
  subscriptions: SubscriptionInfos[];
  handleNewEvent: (event: string) => void;
}

function StompComponent({
  webSocketUrl,
  authToken,
  children,
  subscriptions,
  handleNewEvent,
}: Props) {
  const subbedEventsAndFilters: React.JSX.Element[] = [];

  for (let i = 0; i < subscriptions.length; ++i) {
    subbedEventsAndFilters[i] = (
      <SubscriptionSocket
        key={i}
        subbedEvent={subscriptions[i].subbedEvent}
        pathFilter={subscriptions[i].pathFilter}
        filters={subscriptions[i].filters}
      />
    );
  }

  return (
    <StompSessionProvider url={webSocketUrl}>
      <>
        <SubscriptionsHook
          handleNewEvent={handleNewEvent}
          authToken={authToken}>
          <>
            {subbedEventsAndFilters}
            {children}
          </>
        </SubscriptionsHook>
      </>
    </StompSessionProvider>
  );
}

export default React.memo(StompComponent);
